"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var collapsibleContainerLocal = function collapsibleContainerLocal(theme) {
  return {
    appearance: {
      primary: {
        color: theme.color.monochrome6["default"],
        iconAppearance: 'secondary',
        inverseIcon: false,
        inverse: {
          color: theme.inverseColor.monochrome6["default"],
          iconAppearance: 'primary',
          inverseIcon: true
        }
      },
      secondary: {
        color: theme.color.monochrome6["default"],
        iconAppearance: 'primary',
        inverseIcon: false,
        inverse: {
          color: theme.inverseColor.monochrome6["default"],
          iconAppearance: 'primary',
          inverseIcon: true
        }
      }
    }
  };
};
var _default = collapsibleContainerLocal;
exports["default"] = _default;